import { Immutable } from "immer";
import React from "react";
import { SocialIcons } from "tsi-common-react/src/components/SocialIcons/index";

import { templates } from "@reactivated";

type ITempurLoveSocialIconsProps = Immutable<{
    categories: templates.TempurLoveStoryPageDocumentTemplate["categories"];
    loveRootUrl: string;
    city?: string | null;
    state?: string | null;
    pageUrl: string;
    tileImageUrl: string;
}>;

export const TempurLoveSocialIcons = (
    props: ITempurLoveSocialIconsProps,
): React.JSX.Element => {
    return <SocialIcons {...props} twitterHandle="stearnsandfoster" />;
};
